<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_RESULT_NATURAL'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Результат от реализации проекта в натуральном выражении:</label>
      </p>
      <input
        v-on:keyup="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_RESULT_NATURAL')
        "
        type="text"
        class="i-main-style i-wid-29"
        v-model="$parent.project.UF_RESULT_NATURAL"
        :disabled="$parent.$parent.projectDisabled"
      />
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_RESULT_NATURAL"
          )
        }}
      </div>
    </div>
    <p class="content-info-text">
      В данном поле необходимо указать планируемый объем производимой продукции
      в соответствующих единицах измерения и с указанием продукта проекта за
      период пользования займом Фонда. Например, 20 000 фрез или 15 тыс. тонн
      резиновой крошки.
    </p>
  </div>
</template>

<script>
export default {
  name: "uf_result_natural_f"
};
</script>

<style scoped></style>
